import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";

class VenueRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	async getVenueConfigOld() {
		try {
			const response = await apiRequest({
				url: apiUrl("/world/api/venueconfig"),
				method: "POST",
				body: {},
				token: null,
				throwOnNonOk: false,
			});
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo la información de la venue.");
		}
	}

	async getVenueConfig() {
		const { data, status } = await apiRequest({
			url: apiUrl("/world/api/venueconfig"),
			method: "POST",
			body: null,
			token: null,
			expect: "json",
			throwOnNonOk: false,
		});

		if (status !== 200) {
			const err = new Error(data?.message || `HTTP ${status}`);
			err.status = status;
			err.data = data;
			throw err;
		}

		return data;
	}

	async getElaborationTypes() {
		const { data, status } = await apiRequest({
			url: apiUrl("/world/api/elaborationtype/get"),
			method: "POST",
			body: null,
			token: null,
			expect: "json",
			throwOnNonOk: false,
		});

		if (status !== 200) {
			const err = new Error(data?.message || `HTTP ${status}`);
			err.status = status;
			err.data = data;
			throw err;
		}

		return data;
	}

	async getTables(venueId) {
		try {
			return await apiRequest({
				method: "GET",
				url: apiUrl(`/world/api/venue/${venueId}/rooms?includeTables=1`),
			});
		} catch (e) {
			console.log("Ups, algo ha ido mal comprobando la disponibilidad.", e);
		}
	}

	async getVenueMenus() {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/venuemenus"), method: "POST", body: {}, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo los menus de la venue.");
		}
	}
}

export const venueRepository = new VenueRepository();
